export default () => {
    return (
        <div id="footer">
            <p>&copy; <a href="http://www.brestobl.com">BrestObl</a></p>
        </div>
    );
};